import { createAsyncThunk } from "@reduxjs/toolkit";
import { orderErrorToast, orderSuccessToast } from "../../../app/funcs/orderResultToast";
import { UserPassword } from "../../../domain/user/UserPassword";
import { changePassword } from "./api";

export const ActionType = Object.freeze({
    base: "@@Monitoring/Action/change_password",
    chagnePassword: "changePassword"
});

export const changePasswordAction = createAsyncThunk(
    `${ActionType.base}/${ActionType.chagnePassword}`,
    async(data: { password: UserPassword }) => {
        const response = await changePassword(data.password);

        if (response.error === undefined) {
            // API処理結果正常の場合
            orderSuccessToast("パスワードを変更しました。");
        } else {
            // API処理結果異常の場合
            orderErrorToast("パスワードの変更に失敗しました。\nお手数お掛けしますが\nお問い合わせからご連絡下さい。");
        }
    }
);
